/**
 * One CSV cell, and the two rules every export in this product shares.
 *
 * LIFTED, not written. This was a private `cell()` inside
 * `apps/api/src/contacts/collector-list-export.ts`, where OND-67 put it after
 * moving the collector list's export off the browser. OND-97's gallery
 * reporting export is the second caller, and it runs in the BROWSER — see that
 * model's header for why that export stayed client-side where the collector
 * list's could not. Two copies of a spreadsheet-safety rule is exactly the pair
 * CLAUDE.md names: it would drift, and the symptom would be one export that
 * neutralises a formula and one that does not.
 *
 * It is here rather than in either app because both sides of the wire need it
 * and `@ondo/shared` is the only thing both import. Nothing in this file knows
 * what a row is about.
 */
/**
 * A value, quoted when it could otherwise break the file and neutralised when
 * it could otherwise be executed.
 *
 * A LEADING `=`, `+`, `-` OR `@` IS PREFIXED WITH AN APOSTROPHE. A contact
 * called `=cmd|…`, or a work titled `-1+1`, is a formula injection into
 * whatever spreadsheet opens the file, and these values come from free text
 * somebody typed. Tab and carriage return lead the same way in some
 * spreadsheets and are guarded with them.
 *
 * The quoting is the ordinary CSV rule — a cell holding a quote, a comma or a
 * newline is wrapped and its own quotes doubled — and it is applied AFTER the
 * guard so that an apostrophe-prefixed value is still quoted if it needs to be.
 */
export function csvCell(value) {
    const guarded = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
    return /[",\r\n]/.test(guarded) ? `"${guarded.replaceAll('"', '""')}"` : guarded;
}
/**
 * Rows of cells as a CSV document.
 *
 * CRLF, because that is what the format says and what every spreadsheet on a
 * Windows desktop expects; a file joined with bare newlines opens as one row in
 * some of them. Each cell goes through `csvCell`, so a caller cannot forget.
 */
export function toCsv(rows) {
    return rows.map((cells) => cells.map(csvCell).join(",")).join("\r\n");
}
//# sourceMappingURL=csv.js.map